import { getTestPeriodEndDate } from '@expane/logic/billing/promoCode'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IoCalendarOutline } from 'react-icons/io5'
import { PlanType, ServerGcfPromoCode } from '@expane/data'
import { ChooseButton } from '@expane/ui'
import { useDateFormatting } from '@expane/logic/useDateFormatting'

interface TrialAppSubscriptionInfoProps {
  planType: PlanType | undefined
  timezone: string
  onClick: () => void
  watchedPromoCode?: ServerGcfPromoCode
}

export const TrialAppSubscriptionInfo: FC<TrialAppSubscriptionInfoProps> = ({
  planType,
  timezone,
  onClick,
  watchedPromoCode,
}) => {
  const { t } = useTranslation()

  const formatDate = useDateFormatting(timezone)

  const toDate = getTestPeriodEndDate(timezone, watchedPromoCode)

  const to = formatDate('date', toDate)

  return (
    <div className="flex items-center border-2 rounded-lg p-1 mb-w border-primary-400 bg-accent mb-4">
      <IoCalendarOutline size="2.5rem" className="mr-2 text-billing-main-color" />

      <div>
        <p className={'font-medium text-sm text-billing-main-color'}>
          {t('appSubscription.selectedPlan')}
          {planType ? ` ${t('planType.' + planType)}` : null}
        </p>
        <p className="text-billing-secondary-color text-sm">
          {t('appSubscription.freeUntil', { to })}
        </p>
      </div>

      <ChooseButton className="ml-auto w-40" onClick={onClick} />
    </div>
  )
}
